module.exports = __webpack_public_path__ + "static/img/a08.284e25b4.jpg";